import { BellIcon, Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Badge, Flex } from "@radix-ui/themes";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetStudentDebtiesQuery } from "../../../hooks/useGetStudentDebtiesQuery";
import { setStudentDebtData } from "../../../redux/slices/finance/studentDebt";
import { routes } from "../../../routes";
import { getStudentDebt, updateStudentDebt } from "../../../services/finance/studentDebt";
import { PaymentReferenceType, StudentDebtNotificationType, StudentDebtType } from "../../../types/Finance";
import { Key_studentdebties, PAGE_NUMBER, PAGE_SIZE } from "../../../utils/constants";
import { getPaymentTransactions } from "../../../services/finance/paymentTransaction";
import { createStudentDebtNotification } from "../../../services/finance/studentDebtNotification";
import { createPaymentReference, getReferenceCode, getReferenceCodeV2 } from "../../../services/finance/paymentReference";
import { isEmpty } from "lodash";
import { useGetSchoolBankConfigQuery } from "../../../hooks/useGetSchoolBankConfigQuery";
import RadioGroupComponent from "../../../components/inputs/RadioGroup/RadioGroupComponent";
import { useForm } from "react-hook-form";
import { monthsTranslation } from "../../../utils/months";
import { setPdfPreviewType } from "../../../redux/slices/report/report";
import { getStudentByCode, getStudentById } from "../../../services/school/student/getStudentByCode";
import { getUserById } from "../../../services/user/getUsers";
import { resetStudentData, setStudentData } from "../../../redux/slices/school/student";
import { resetUserData, setUserData } from "../../../redux/slices/users/user";
import { setPaymentsTransactionsData } from "../../../redux/slices/finance/paymentTransaction";
import { ReasonsToDeleteStudentDebt } from "../../../utils/codes";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const columnNamesMap: { [key: string]: string } = {
  fullname:"Estudante",
  paymentType:"Tipo de pagamento", 
  originalAmount: "Valor a pagar",
  currentAmount: "Valor remanescente",
  monthView: "Mês",
  dueDate: "Ate data a pagar",
  description: "Descrição",
  isPayedIcon: "Pago ?",
  paidDate: "Data de pagamento",
};

export const StudentDebts = () => {
  const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
    const [pageSize, setPageSize] = useState(PAGE_SIZE); 
    const loggedUserData = useSelector((state: RootState) => state.login.userData)

    const [searchTerm, setSearchTerm] = useState('');  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetStudentDebtiesQuery({ PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm },
    {
       refetchOnWindowFocus: false,
    }
  );
  const { data: schoolBankConfigsData, status:schoolBankConfigsStatus } = useGetSchoolBankConfigQuery({ PageNumber: currentPage, PageSize: 400 });
  
  const [deleteItem, setDeleteItem] = useState<StudentDebtType | null>(null);
  const [generateRefItem, setGenerateRefItem] = useState<StudentDebtType | null>(null);
  const mutationUpdate = useMutation(updateStudentDebt, {
    onSuccess: () => {
        queryClient.invalidateQueries(Key_studentdebties);
        toast.success('Cobrança apagada');
    },
    onError: () => {
        toast.error("Erro ao apagar Cobrança")
    }
});
const mutationSaveStudentDebtNotification = useMutation({ mutationFn: createStudentDebtNotification, mutationKey: 'createStudentDebtNotification' });
const mutationSaveReferenceCode = useMutation({ mutationFn: createPaymentReference, mutationKey: 'createPaymentReference' });

  const { control, handleSubmit, setValue, formState: { errors }, reset, getValues,watch } = useForm<{
    bankEntity: string; 
    deletedReason?: string; 
    deletedReasonOther?: string; 
  }>({
    defaultValues:{
      bankEntity:"",
      deletedReason:"1"
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  })



  const handlePageChange = (page: number) => {
    setCurrentPage(page);
};
const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(PAGE_NUMBER); 
};

const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1); 
};
const handleClickCreate = (event: any): void => {
  navigate(routes.createStudentDebt)
}
const handleEdit = (c: StudentDebtType) => {
  c.isPayedIcon = '';

  if(c.currentAmount != c.originalAmount || c.isPayed){
    toast.error("Não pode editar Cobrança")
    return;
  }
  dispatch(setStudentDebtData(c));
  navigate(routes.updateStudentDebt)
  
};
const handleDelete = (c: StudentDebtType) => {
  c.status = false;
  c.isPayedIcon = '';
  c.deletedReason = getValues('deletedReason');
  c.deletedReasonOther=`${getValues('deletedReasonOther')??""} ação realizada por ${loggedUserData?.Fullname}` ;
  mutationUpdate.mutateAsync(c)
};
const handlePayStudentDebt = async(c: StudentDebtType) => {
  if(c.isPayed){
    toast.success("Cobrança paga");
    return;
  } 
  try{
    let {items} = await getPaymentTransactions({PageSize: 4000, PageNumber:1, IdStudentDebt: c.id})
    items = items.filter(i=> i.idStudentDebt===c.id);
    c.isPayedIcon = '';
    c.paymentTransation = items;
    dispatch(setStudentDebtData(c));
    navigate(routes.payStudentDebt)
  }catch{
    toast.error("Ops! Ocorreu um erro");
  }
};
const handleCheckPayments = async(c: StudentDebtType) => {
  c.isPayedIcon = '';
  try{
    let {items} = await getPaymentTransactions({PageSize: 4000, PageNumber:1, IdStudentDebt: c.id})
    items = items.filter(i=> i.idStudentDebt===c.id);
    c.isPayedIcon = '';
    c.paymentTransation = items;
    dispatch(setStudentDebtData(c));
    navigate(routes.checkPayments)
  }catch{
    toast.error("Ops! Ocorreu um erro");
  }
};
const handleNotifyStudentDebt =async (c: StudentDebtType) => {
  c.isPayedIcon = '';
  if(c.isPayed){
    toast.error("Cobrança paga, não será possivel notificar estudante");
    return;
  }
  try {
    const data: StudentDebtNotificationType ={
      idStudentDebt: c.id!,
      isViewed: false,
      message:` Pagamento de ${c.paymentType},  ${c.description??""} No valor de ${c?.currentAmount?.toFixed(1)}Mtn` ,
      status: true
    };
    await mutationSaveStudentDebtNotification.mutateAsync(data);
    toast.success("Estudante notificado");

  } catch (error) {
    toast.error("Ops, ocorreu um erro!");
  }
};

const openDeleteDialog = (c: StudentDebtType) => {
  if(c.isPayed){
    toast.error("Cobrança paga, não será possivel apagar");
    return;
  }
  if(c.currentAmount !=c.originalAmount){
    toast.error("Cobrança em pagamento, não será possivel apagar");
    return;
  }
  setDeleteItem(c);
};  
const confirmDelete = async () => {
  if (deleteItem) {
      await handleDelete(deleteItem!)
  }
};

const openGenerateRefDialog = (c: StudentDebtType) => {
  if(c.isPayed){
    toast.error("Cobrança paga, não será possivel gerar referencia");
    return;
  }
  setGenerateRefItem(c);
};  

const confirmGenerateRef = async () => {
  if (generateRefItem ) {
      await handleGenerateReference(generateRefItem!)
  }
};
const handleGenerateReference = async (c: StudentDebtType) => {
  if(c.isPayed){
    toast.error("Pago, não será possivel gerar referencia");
    return;
  }
  try{
    const bankEntity = getValues('bankEntity'); 
    if(isEmpty(bankEntity)){
      toast.error("Selecione uma entidade bancaria");
      return;
    } 
    const currentDate = new Date(); 
    let referenceCode = '';
    const getReferenceCodeRequest = {
      amount: c.currentAmount,  
      idStudent: c.idStudent,
      idPaymentType: c.idPaymentType,
      idStudentDebt: c.id,
      month:(currentDate.getMonth()+1).toString(),
      year: currentDate.getFullYear().toString(),
      description: c.description,
      idBankEntity:bankEntity, 
      entity: String(schoolBankConfigsData?.items.find(i=> i.id===getValues('bankEntity'))?.bankEntity)
    }
    try{
      referenceCode = await getReferenceCodeV2(getReferenceCodeRequest);
    }catch(ex:any){
      toast.error(ex?.message);
      return;
    }
    if(isEmpty(referenceCode)){
      toast.error("Ops, não foi possivel gerar referencia");
      return;
    }
    const  data:PaymentReferenceType = {
      idStudent: c.idStudent,
      idPaymentType: c.idPaymentType,
      amount: c.currentAmount,
      dueDate: new Date(c.dueDate).toISOString(),
      referenceCode: referenceCode, 
      idStudentDebt: c.id,
      entity: String(schoolBankConfigsData?.items.find(i=> i.id===getValues('bankEntity'))?.bankEntity) ,
      idBankEntity: bankEntity
    }
    await mutationSaveReferenceCode.mutateAsync(data)
    toast.success("Referencia gerada");
    reset();
    c.referenceCode = referenceCode;
    c.entityCode = getReferenceCodeRequest.entity;
    try {
      const studentData = await getStudentById(c.idStudent);
      const userData = await getUserById(studentData.idUser)
      dispatch(setStudentData(studentData));
      dispatch(setUserData(userData));
    } catch (error) {
      dispatch(resetStudentData());
      dispatch(resetUserData());
    }
    dispatch(setStudentDebtData({...c }))
    dispatch(setPdfPreviewType('INVOICE'))
    navigate(routes.pdfPreview);
  }catch(ex){
    toast.error("Ops, ocorreu um erro!");
  }
};
const handlePrintReceipt =async (c: StudentDebtType) =>{
  if(!c.isPayed){
    toast.error("Ainda não foi pago");
    return;
  }
  try{
    const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
    const paymentsTransactions = studentDebtDataRequest?.items
    .flatMap((sdr) => sdr.paymentTransactions || []) 
    .filter((ref) => ref?.id)
    .filter((ref)=> ref.status); 
    const studentDebt = studentDebtDataRequest?.items.at(0)!
    try {
      const studentData = await getStudentById(studentDebt.idStudent);
      const userData = await getUserById(studentData.idUser)
      dispatch(setStudentData(studentData));
      dispatch(setUserData(userData));
    } catch (error) {
      console.error(error)
    }
    dispatch(setPaymentsTransactionsData(paymentsTransactions))
    dispatch(setStudentDebtData(studentDebt))
    dispatch(setPdfPreviewType('RECEIPT'))
    navigate(routes.pdfPreview)
  }catch(error){
    console.error(error)
  }
}
const handlePrintInvoice =async (c: StudentDebtType) =>{
  try{
    const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
    const paymentReferences = studentDebtDataRequest?.items
    .flatMap((sdr) => sdr.paymentReferences || []) 
    .filter((ref) => ref?.id)
    .filter((ref)=> ref.status); 
    let studentDebt = studentDebtDataRequest?.items?.at(0)!;
    const paymentReference = paymentReferences?.find(p=> p.amount===studentDebt.originalAmount);
    if(paymentReference){
      studentDebt.entityCode = paymentReference.entity;
      studentDebt.referenceCode = paymentReference.referenceCode;
      studentDebt.bankDescription = schoolBankConfigsData?.items.find(i=> i.bankEntity==paymentReference.entity)?.bankDescription ?? schoolBankConfigsData?.items.find(i=> i.bankEntity==paymentReference.entity)?.bankName ?? "";
      studentDebt.bankName = schoolBankConfigsData?.items.find(i=> i.bankEntity==paymentReference.entity)?.bankName ?? "";
    }
    try {
      const studentData = await getStudentById(studentDebt.idStudent);
      const userData = await getUserById(studentData.idUser)
      dispatch(setStudentData(studentData));
      dispatch(setUserData(userData));
    } catch (error) {
      console.error(error)
    }
    dispatch(setStudentDebtData(studentDebt))
    dispatch(setPdfPreviewType('INVOICE'))
    navigate(routes.pdfPreview)
  }catch(error){
    console.error(error)
  }
}
const options = data?.items.map(() => [
  {
      label: 'Editar',
      onClick: (c: StudentDebtType) => handleEdit(c),
      icon: <Pencil1Icon />
  },
  {
      label: 'Pagar',
      onClick: (c: StudentDebtType) => handlePayStudentDebt(c),
      icon: <Pencil1Icon />
  },
  {
      label: 'Transações de pagamento',
      onClick: (c: StudentDebtType) => handleCheckPayments(c),
      icon: <Pencil1Icon />
  },
  {
      label: 'Notificar Cobrança',
      onClick: (c: StudentDebtType) => handleNotifyStudentDebt(c),
      icon: <BellIcon />
  },
  {
      label: 'Gerar referência de pagamento',
      onClick: (c: StudentDebtType) => openGenerateRefDialog(c),
      icon: <BellIcon />
  },
  {
      label: 'Imprimir cobrança',
      onClick: (c: StudentDebtType) => handlePrintInvoice(c),
      icon: <BellIcon />
  },
  {
      label: 'Imprimir recibo',
      onClick: (c: StudentDebtType) => handlePrintReceipt(c),
      icon: <BellIcon />
  },
  {
      label: 'Excluir',
      onClick: (c: StudentDebtType) => openDeleteDialog(c),
      icon: <TrashIcon />
  }
]) || [];



  function handleSelectReason(value: string): void {
    setValue('deletedReason', value)
  }

return (
  <>
      <Lists
          status={status}
          TableComponent={() =>
              <TableComponent
                  columns={Object.keys(columnNamesMap)}
                  items={data?.items.map(item=> {
                    return {...item, 
                      monthView: (monthsTranslation[item?.month as keyof typeof monthsTranslation] || item?.month) ?? "N/D",
                      isPayedIcon: item.isPayed?<><Badge color="green">
                       Pago
                   </Badge> </>: 
                   <Badge color="red">
                     Não pago
                  </Badge> 
                    }
                  })}
                  options={options}
                  columnNamesMap={columnNamesMap}
                  totalPages={data?.totalPages || 1}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange} 
                    onSearch={handleSearch}
                    search={searchTerm}
                    totalItems={data?.totalItems}
                    enableExportToExcel={true}
              />
          }
          handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
          open={!!deleteItem}
          onOpenChange={(open) => !open && setDeleteItem(null)}
          title="Esta operação é irreversível"
      descriptionComponent={<>
      <Flex direction='column' gap='2'>
        <SelectComponent
          name="deletedReason"
          label="Motivo"
          control={control}
          errors={errors}
          composedName={{ parent: "student", prop: 'province' }}
          options={ReasonsToDeleteStudentDebt?.map((r: { id: any, description: any }) => ({
            value: r.id,
            label: r.description ?? "",
          }))}
          style={{ width: '100%' }}
          onSelect={handleSelectReason}
        />
          <TextFieldComponent name="deletedReasonOther" label="Descrição" control={control} errors={errors} style={ {width:"100%", display: watch('deletedReason')==='2'? "initial":"none"} } />
      </Flex>

          </>}
          item={deleteItem}
          onConfirm={confirmDelete}
          onCancel={() => setDeleteItem(null)}
      />
      <ConfirmAlertDialog
          open={!!generateRefItem}
          descriptionComponent={
            <>
              <RadioGroupComponent name="bankEntity" control={control} errors={errors} label="Entidade" style={{ width: '100%' }}
                options={schoolBankConfigsData?.items.map(i => {
                  return {
                    value: String(i.id!),
                    label: String(i.bankEntity!)
                  }
                }) ??[]
                }
                fieldProps={{
                  style: { display: 'flex', flexDirection: 'row', gap: '16px' }
                }}
                required={true}
              />
            </>
          }
          
          onOpenChange={(open) => !open && setGenerateRefItem(null)}
          title="Esta operação é irreversível"
          item={generateRefItem}
          onConfirm={confirmGenerateRef}
          onCancel={() => setGenerateRefItem(null)}
      />
  </>
);
}
